import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MemberTab from "../ui/TabSection";
import { useAppSelector } from "../../redux/hooks";
import { useParams } from "react-router-dom";
import { LoyaltyPoints } from "./LoyaltyPoints";
import MemberReceiptTab from "../../pages/MemberReceiptTab";
import CarParkLogs from "./CarParkLogs";
import { getFeaturePermissions } from "../../util/permissions";
import MemberDetailsHeaderNew from "./MemberDetailsHeaderNew";
import useGetCarparkBalance from "../../Hooks/carpark/useGetCarparkBalance";
import ProfileNew from "./ProfileNew";
import EvoucherTabNew from "./EvoucherTabNew";
import { usePermissionGetter } from "../../Hooks/Permissions/userPermissionGetter";
import { selectFeaturePermissions } from "../../redux/selectors/loginSelector";
import { permissionsConstants } from "../../constants/AppConstants";

const ViewMemberDetails = () => {

  localStorage.removeItem('isFromRedirect');
  localStorage.removeItem('redirect-data');

  
  const featurePermissions = useAppSelector(selectFeaturePermissions);
  const tabList: any = [
    {
      feature: "members_search",
      title: "Profile",
    },
    {
      feature: "points",
      title: "Points",
    },
    {
      feature: "evouchers",
      title: "e-Voucher",
    },
    {
      feature: "receipts",
      title: "Receipts",
    },
    {
      feature: "carpark_logs",
      title: "Car Park Log",
    },
  ];
  const { getUserPermission: getProfilePermission } = usePermissionGetter(
    "members",
    "members_search"
  );
  const { getUserPermission: getPointsPermission } = usePermissionGetter(
    "members",
    "points"
  );
  const { getUserPermission: getEvoucherPermission } = usePermissionGetter(
    "members",
    "evouchers"
  );
  const { getUserPermission: getReceiptPermission } = usePermissionGetter(
    "members",
    "receipts"
  );
  const { getUserPermission: getCarParkPermission } = usePermissionGetter(
    "members",
    "carpark_logs"
  );
  const theme = useTheme();
  const params = useParams();
  const permissions = useAppSelector(
    (state: any) => state.persistReducers.login.permissions
  );
  const { memberId } = params;
  // const authorizedTabList = tabList.filter(
  //   (list: any) =>
  //     getFeaturePermissions(permissions, "Member", list.feature).read
  // );
  const authorizedTabList = tabList.filter((tab: any) => {
    const permissionsForMember =
      featurePermissions[permissionsConstants.members];
    const permission = permissionsForMember
      ? permissionsForMember[tab.feature]
      : null;
    return permission && permission.read === true;
  });
  const [tabState, setTabState] = useState<string>(() => {
    // const activeTab = sessionStorage.getItem("member-tab");
    // return activeTab ? activeTab : authorizedTabList[0].title;
    return authorizedTabList[0].title;
  });
  const memberDetails = useAppSelector(
    (state: any) => state.persistReducers.getMemberList?.membersList
  );


  const loyaltyPoints = useAppSelector(
    (state: any) => state.persistReducers.pointsSlice.points
  );
  const { getCarparkBalance, balance } = useGetCarparkBalance();
  useEffect(() => {
    getCarparkBalance(memberDetails);
    setTabState(tabState ?? authorizedTabList[0].title);
  }, []);

  const handleTabSwitch = (key: any) => {
    sessionStorage.setItem("member-tab", key);
    switch (key) {
      case "Profile":
        return (
          <Grid height={"100%"}>
            {getProfilePermission("read") && <ProfileNew />}
          </Grid>
        );
      case "Points":
        return (
          <Grid item>
            {getPointsPermission("read") && (
              <LoyaltyPoints
                loyaltyPointsValue={loyaltyPoints}
                formData={memberId}
              />
            )}
          </Grid>
        );
      case "e-Voucher":
        return (
          <Grid p={2}>
            {getEvoucherPermission("read") && <EvoucherTabNew />}
          </Grid>
        );

      case "Messages":
        return (
          <Grid
            p={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100%"
          >
            <img
              src={require("../../assets/comingsoon.png")}
              alt="Coming Soon..!"
              style={{ maxWidth: "200%" }}
            />
          </Grid>
        );
      case "Receipts":
        return (
          <Grid p={2}>
            {getReceiptPermission("read") && <MemberReceiptTab />}
          </Grid>
        );
      case "Car Park Log":
        return (
          <Grid p={2}>{getCarParkPermission("read") && <CarParkLogs />}</Grid>
        );

      default:
        return (
          <Grid
            p={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100%"
          >
            <img
              src={require("../../assets/comingsoon.png")}
              alt="Coming Soon..!"
              style={{ maxWidth: "200%" }}
            />
          </Grid>
        );
    }
  };

  const displayMemberDetailsHeader = () => {
    return (
      <Grid
        sx={{ backgroundColor: theme?.color?.background }}
        display={"flex"}
        height={"8vh"}
        borderBottom={`${theme?.border?.xsmall} ${theme?.color?.dividerLight}`}
        pl={2}
      >
        <MemberTab
          tabList={authorizedTabList}
          setParentTabState={setTabState}
          selectedTab={tabState}
        />
      </Grid>
    );
  };
  return (
    <Grid display={"flex"} gap={2}>
      <Grid
        display={"flex"}
        justifyContent={"center"}
        alignItems={"start"}
        height={"100%"}
        width={"25%"}
      >
        <MemberDetailsHeaderNew
          pointsValidityData={memberDetails && memberDetails.expirySchedules}
          expiryDate={memberDetails && memberDetails.expiry_points_date}
          nextSlab={memberDetails && memberDetails.nextSlab}
          expiryPoints={memberDetails && memberDetails.expiry_points}
          email={memberDetails && memberDetails.email}
          memberSince={memberDetails && memberDetails.join_date}
          memberName={
            memberDetails && memberDetails.first_name
              ? `${memberDetails.first_name} ${memberDetails.last_name}`
              : "-"
          }
          memberTier={memberDetails && memberDetails.currentSlab}
          slabExpiryDate={memberDetails && memberDetails.slabExpiryDate}
          loyaltyNo={memberDetails && memberDetails.loyaltyId}
          status={
            memberDetails && memberDetails.customer_status
              ? memberDetails.customer_status
              : "-"
          }
          loyaltyPoints={
            loyaltyPoints > 0 ? loyaltyPoints : memberDetails.loyaltyPoints
          }
          min_purchase_value_required={
            memberDetails && memberDetails.min_purchase_value_required
          }
          carpark={balance ? balance : "0"}
          gap_to_upgrade={memberDetails && memberDetails.gap_to_upgrade}
          upgrade_by={memberDetails && memberDetails.upgrade_by}
          gap_to_renew={memberDetails && memberDetails.gap_to_renew}
          renew_by={memberDetails && memberDetails.renew_by}
          currentSlab={memberDetails && memberDetails.currentSlab}
          yuuId={memberDetails && memberDetails.yuu_tomo_id}
          yuu_status={memberDetails && memberDetails?.yuu_linking_status}
          show_yuu ={true}
        />
      </Grid>
      <Grid
        width={"75%"}
        sx={{
          background: theme.color?.background,
          borderRadius: 4,
        }}
        overflow={"hidden"}
      >
        {displayMemberDetailsHeader()}
        <Grid height={"90%"}>{handleTabSwitch(tabState)}</Grid>
      </Grid>
    </Grid>
  );
};

export default ViewMemberDetails;
